export default __webpack_public_path__ + "static/media/QRacingQueensland.16c27528.svg";